import PropTypes from 'prop-types';
import { Box, Grid, useTheme } from '@mui/material';
import { COLLECTION_STEPS_CONFIG } from './config';
import { StepsList } from './components/StepsList';

const Collection = ({ shipment, dropAtShop }) => {
  const theme = useTheme();

  return (
    <Grid sx={{ background: theme.vars.palette.background.paper }}>
      <Grid container alignItems='center' justifyContent='center'>
        <Grid
          alignItems='center'
          justifyContent='center'
          spacing={2}
          sx={{ mt: 0 }}
        >
          <Grid
            size={{
              xs: 12,
              md: 12,
            }}
          >
            <Grid sx={{ mt: 1 }}>
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <StepsList
                  config={COLLECTION_STEPS_CONFIG(shipment, dropAtShop)}
                />
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

Collection.propTypes = {
  shipment: PropTypes.object,
};

export default Collection;
